import { buildBracketGraphAndAssignMatchTitles } from "model/Bracket/BracketGraph";
import { buildShuffleBracketGraphAndAssignMatchTitles } from "model/Bracket/ShuffleBracketGraph";
import { nonUndefined } from "Utility";
import { mapBracketMatchs } from "./FsBracketMatch";
import {
  FsBracket,
  FsBracketSegment,
} from "db/model/tournament/Segment/Bracket/FsBracket";
import {
  Bracket,
  BracketSegment,
  isBracketType,
} from "model/Tournament/Segment/Bracket/Bracket";
import { mapTournamentSegmentBase } from "../FsTournamentSegment";
import { mapTournamentSegmentGroupBase } from "../FsTournamentSegmentGroup";

export const mapBracketSegment = (
  fsModel: FsBracketSegment
): BracketSegment | undefined => {
  return mapTournamentSegmentBase(fsModel, fsModel.type, mapBrackets);
};

const mapBrackets = (fsModels: FsBracket[]): Bracket[] => {
  return nonUndefined(fsModels.map(mapBracket));
};

const mapBracket = (fsModel: FsBracket): Bracket | undefined => {
  if (!fsModel.bracketType || !isBracketType(fsModel.bracketType)) {
    return undefined;
  }

  const matches = mapBracketMatchs(nonUndefined(fsModel.matches ?? []));
  const graph =
    fsModel.bracketType === "SingleElimShuffle" ||
    fsModel.bracketType === "DoubleElimShuffle" ||
    fsModel.bracketType === "Multilevel"
      ? buildShuffleBracketGraphAndAssignMatchTitles(
          matches,
          fsModel.bracketType
        )
      : buildBracketGraphAndAssignMatchTitles(matches, fsModel.bracketType);

  return {
    ...mapTournamentSegmentGroupBase(fsModel),
    bracketType: fsModel.bracketType,
    graph: graph,
    matches,
    name: fsModel.name,
  };
};
